module.exports = __webpack_public_path__ + "img/xt1v1.df7a939d.png";